var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBulletCheck6Fa2B6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM14.71 6.29C15.1 6.68 15.1 7.31 14.71 7.7L8.71 13.7C8.51 13.9 8.26 13.99 8 13.99C7.74 13.99 7.49 13.89 7.29 13.7L5.29 11.7C4.9 11.31 4.9 10.68 5.29 10.29C5.68 9.9 6.31 9.9 6.7 10.29L7.99 11.58L13.28 6.29C13.67 5.9 14.3 5.9 14.69 6.29H14.71Z",
    fill: "#6FA2B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulletCheck6Fa2B6);
export default __webpack_public_path__ + "static/media/icon_bullet_check_6FA2B6.c1ce703afe5bb9008afab0342da9e087.svg";
export { ForwardRef as ReactComponent };